export const STORE_CUSTOM_FIELDS_RAW_STATE_KEY = 'store-customFieldsRaw' as const;
